import { Inject, Injectable, Injector } from '@angular/core';

import { Observable } from 'rxjs';
import {
  EnderecoRequest,
  EnderecoResponse,
  EnderecoUpdateRequest,
} from '../../../models/endereco.models';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';

@Injectable({
  providedIn: 'root',
})
export class NewApiEnderecoService extends UtilsBaseApiService<NewApiEnderecoService> {
  readonly CLIENTE_CONTEXT = 'cliente';
  private readonly MAIN_ADRESS_CONTEXT = 'find-endereco-principal';

  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector
  ) {
    super('endereco', injector, environment.BASE_API_URL);
  }

  getMainAdressByCodigoCliente(codigoCliente: string | number) {
    return this.httpClient.get<any>(
      `${this.BASE_URL}${this.CONTEXT}/${this.MAIN_ADRESS_CONTEXT}?${this.getQueryString({clientId: codigoCliente})}`
    );
  }

  getEnderecoByCodigoCliente(codigoCliente: string | number) {
    return this.httpClient.get<EnderecoResponse[]>(
      `${this.BASE_URL}${this.CONTEXT}/${this.CLIENTE_CONTEXT}?${this.getQueryString({codigoCliente})}`
    );
  }

  createEndereco = (endereco: EnderecoRequest) =>
    this.create<EnderecoRequest, EnderecoResponse>(endereco);
  updateEndereco = (endereco: EnderecoUpdateRequest) =>
    this.update<EnderecoResponse>(endereco);

  deleteEndereco(idEndereco: number | string): Observable<boolean> {
    return this.httpClient.delete<boolean>(
      `${this.BASE_URL}${this.CONTEXT}?${this.getQueryString({idEndereco})}`
    )
  };
}
